import React, { createContext, useContext, useState, useCallback } from 'react';
import type { Language, ContentType } from '../data/content';
import { content } from '../data/content';

interface LanguageContextType {
  lang: Language;
  t: ContentType;
  toggleLanguage: () => void;
  setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Language>('en');

  const toggleLanguage = useCallback(() => {
    setLangState((prev) => (prev === 'en' ? 'es' : 'en'));
  }, []);

  const setLanguage = useCallback((newLang: Language) => {
    setLangState(newLang);
  }, []);

  const t = content[lang];

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
